import { ref } from 'vue';
import { useRoute } from 'vue-router';
import { MODALS } from '@/components/popup/commonModals';

export default function useModalData() {
  const route = useRoute();
  const pageName = route.name;
  const pageType = ref('');

  switch (pageName) {
    case 'CustomerOrganizationDetails':
      pageType.value = MODALS.USERS;
      break;
    case 'PartnerOrganizationDetails':
      pageType.value = MODALS.USERS;
      break;
    default:
      pageType.value = '';
  }

  return { pageType };
}
